import { TableCellTypes } from '@carboledger/ui';

// Shared attachments table — S.No / Name / Last updated on; actions come from rowActions.
export const buildAttachmentsColumns = (t) => [
  {
    id: 'serialNo',
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 140,
    sortable: true,
  },
  {
    id: 'name',
    header: t('ATTACHMENT_COL_NAME'),
    type: TableCellTypes.text,
    width: 210,
    sortable: true,
  },
  {
    id: 'lastUpdatedOn',
    header: t('ATTACHMENT_COL_LAST_UPDATED_ON'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
];
